(function () {
  'use strict';

  angular.module('app').component('bookingItemStandardCostBased', bookingItemStandardCostBased());

  function bookingItemStandardCostBased() {
    return {
      bindings: {
        bookingItem: '=',
        booking: '<',
        documentDateExchangeRate: '<',
        onBookingItemStandardCostBasedSaved: '&',
        changeCostType: '<',
      },
      controller: BookingItemStandardCostBasedCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/components/' +
        'booking-item-standard-cost-based/booking-item-standard-cost-based.component.html',
    };
  }

  BookingItemStandardCostBasedCtrl.$inject = [
    'UtilService',
    'AvailabilityService',
    'moment',
    'TourService',
    'TransportationService',
    'TaxService',
    'ExchangeRateService',
    'BookingItemNotificationService',
    'ModalWindowConfirmService',
  ];

  function BookingItemStandardCostBasedCtrl(
    UtilService,
    AvailabilityService,
    moment,
    TourService,
    TransportationService,
    TaxService,
    ExchangeRateService,
    BookingItemNotificationService,
    ModalWindowConfirmService
  ) {
    let vm = this;

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.selectAssociatedProvider = selectAssociatedProvider;
    vm.saveBookingItemStandardCostBased = saveBookingItemStandardCostBased;

    vm.$onInit = function () {
      vm.loadingAvailability = true;

      vm.enableSendEmailCheckBox = true;

      vm.currencySymbol = vm.booking.currency.symbol;
      vm.decimalPlaces = vm.booking.currency.decimal_places;

      if (!vm.changeCostType) {
        vm.originalBookingItemProviderId = angular.copy(vm.bookingItem.provider_id);
        vm.associatedProviderSelectedId = vm.originalBookingItemProviderId;
        vm.associatedProviderSelected = null;
      }

      vm.bookingItemNetPrice = vm.bookingItem.net_price;
      vm.bookingItemNetCost = vm.bookingItem.net_cost;
      vm.bookingItemNetProfit = vm.bookingItem.net_price - vm.bookingItem.net_cost;

      switch (vm.bookingItem.booking_type) {
        case 'tour':
          getTour();
          break;
        case 'transportation':
          getTransportation();
          break;
        case 'hotel':
          // console.log('getHotels');
          break;
      }
    };

    function getTour() {
      let params = {
        costs: false,
        taxes: true,
        skip_check_role: true,
      };

      TourService.getTour(vm.bookingItem.tour_id, params).then(function (data) {
        vm.product = data;

        let associatedProviders = data.associated_providers.filter(
          (associatedProvider) => associatedProvider.status
        );
        vm.associatedProviders = angular.copy(associatedProviders);

        getProvidersCostAndPrices();
      });
    }

    function getTransportation() {
      let params = {
        costs: false,
        taxes: true,
        skip_check_role: true,
      };

      TransportationService.getTransportation(vm.bookingItem.transportation_id, params).then(
        function (data) {
          vm.associatedProviders = angular.copy(data.associated_providers);

          getProvidersCostAndPrices();
        }
      );
    }

    // Check product costs/prices for a provider
    function getProvidersCostAndPrices() {
      vm.providerTableWidth = 100 / vm.associatedProviders.length;

      let params = {
        product_type: vm.bookingItem.booking_type,
        start_date: vm.bookingItem.start_date,
        end_date: vm.bookingItem.end_date,
        adults: vm.bookingItem.adults,
        children: vm.bookingItem.children,
        infants: vm.bookingItem.infants,
        seniors: vm.bookingItem.seniors,
        price_list_id: vm.bookingItem.price_list_id,
        booking_price_list_id: vm.booking.price_list_id,
        client_id: vm.booking.client_id,
        company_id: vm.booking.company_id,
        skip_check_role: true,

        tour_id: null,
        tour_option_id: null,
        tour_option_schedule_id: null,
        transportation_id: null,
        transportation_schedule_id: null,
      };

      switch (vm.bookingItem.booking_type) {
        case 'tour':
          params.tour_id = vm.bookingItem.tour_id;
          params.tour_option_id = vm.bookingItem.tour_option_id;
          params.tour_option_schedule_id = vm.bookingItem.tour_option_schedule_id;

          vm.productCostType = 'per_person';
          break;
        case 'transportation':
          params.transportation_id = vm.bookingItem.transportation_id;
          params.transportation_schedule_id = vm.bookingItem.transportation_schedule_id;

          vm.productCostType =
            vm.bookingItem.detail.schedule_type === 'open' ? 'per_service' : 'per_person';
          break;
        // TODO hotels ?
      }

      let applyExchangeRateConversion = (amount) =>
        ExchangeRateService.applyExchangeRateConversion(amount, vm.documentDateExchangeRate);

      AvailabilityService.getProvidersCostAndPrices(params).then(function (data) {
        // TODO: What about current prices and commission ? we need to call it from the api

        vm.clientCommissionPercentage = vm.bookingItem.commission_price_percentage;

        if (vm.productCostType === 'per_person') {
          vm.bookingItemAdultsPrice =
            vm.bookingItem.adults *
            (vm.bookingItem.adult_price -
              (vm.bookingItem.adult_price * vm.clientCommissionPercentage) / 100);

          vm.bookingItemChildrenPrice =
            vm.bookingItem.children *
            (vm.bookingItem.child_price -
              (vm.bookingItem.child_price * vm.clientCommissionPercentage) / 100);

          vm.bookingItemInfantsPrice =
            vm.bookingItem.infants *
            (vm.bookingItem.infant_price -
              (vm.bookingItem.infant_price * vm.clientCommissionPercentage) / 100);

          vm.bookingItemSeniorsPrice =
            vm.bookingItem.seniors *
            (vm.bookingItem.senior_price -
              (vm.bookingItem.senior_price * vm.clientCommissionPercentage) / 100);
        } else {
          vm.bookingItemServicePrice =
            vm.bookingItem.seniors *
            (vm.bookingItem.item_price -
              (vm.bookingItem.item_price * vm.clientCommissionPercentage) / 100);
        }

        data.item_costs.forEach(function (providerCost) {
          // Provider has costs
          if (providerCost.costs) {
            for (let i = 0; i < vm.associatedProviders.length; i++) {
              let associatedProvider = vm.associatedProviders[i];

              if (associatedProvider.provider_id === providerCost.provider_id) {
                associatedProvider.has_costs = true;

                if (vm.productCostType === 'per_person') {
                  associatedProvider.adult_cost = applyExchangeRateConversion(
                    providerCost.costs.adult_cost
                  );

                  associatedProvider.adults_cost =
                    vm.bookingItem.adults * associatedProvider.adult_cost;
                  associatedProvider.adults_profit =
                    vm.bookingItemAdultsPrice - associatedProvider.adults_cost;

                  associatedProvider.child_cost = applyExchangeRateConversion(
                    providerCost.costs.child_cost
                  );

                  associatedProvider.children_cost =
                    vm.bookingItem.children * associatedProvider.child_cost;
                  associatedProvider.children_profit =
                    vm.bookingItemChildrenPrice - associatedProvider.children_cost;

                  associatedProvider.infant_cost = applyExchangeRateConversion(
                    providerCost.costs.infant_cost
                  );

                  associatedProvider.infants_cost =
                    vm.bookingItem.infants * associatedProvider.infant_cost;
                  associatedProvider.infants_profit =
                    vm.bookingItemInfantsPrice - associatedProvider.infants_cost;

                  associatedProvider.senior_cost = applyExchangeRateConversion(
                    providerCost.costs.senior_cost
                  );

                  associatedProvider.seniors_cost =
                    vm.bookingItem.seniors * associatedProvider.senior_cost;
                  associatedProvider.seniors_profit =
                    vm.bookingItemSeniorsPrice - associatedProvider.seniors_cost;

                  associatedProvider.item_cost =
                    associatedProvider.adults_cost +
                    associatedProvider.children_cost +
                    associatedProvider.infants_cost +
                    associatedProvider.seniors_cost;
                } else {
                  associatedProvider.item_cost = applyExchangeRateConversion(
                    providerCost.costs.service_cost
                  );
                }

                associatedProvider.net_profit =
                  vm.bookingItemNetPrice - associatedProvider.item_cost;

                break;
              }
            }
          }
        });

        vm.bestUtilProviderId = vm.UtilService.getHighestItemValueFromArray(
          vm.associatedProviders,
          // 'total_profit'
          'net_profit'
        ).id;

        vm.loadingAvailability = false;
      });
    }

    function selectAssociatedProvider(associatedProvider) {
      if (associatedProvider.provider_id !== vm.originalBookingItemProviderId) {
        vm.enableSendEmailCheckBox = false;
      } else {
        vm.enableSendEmailCheckBox = true;
      }

      vm.associatedProviderSelectedId = associatedProvider.provider_id;
      vm.associatedProviderSelected = associatedProvider;

      vm.bookingItemNetCost = associatedProvider.item_cost;
      vm.bookingItemNetProfit = vm.bookingItemNetPrice - vm.bookingItemNetCost;
    }

    function openSendNotificationToProviderModal(booking_item, confirm_callback) {
      let successCallback = function (dataObj) {
        // vm.getBooking(); // Check if needed - we only need to update the notification and status

        booking_item.status = dataObj.booking_item_status;
        booking_item.confirmation_status_mode = dataObj.booking_item_confirmation_status_mode;

        vm.booking.status = dataObj.booking_status;
      };

      BookingItemNotificationService.openSendNotificationToPreviousProvider(
        vm.booking.company_id,
        booking_item,
        null,
        vm.associatedProviderSelected,
        confirm_callback,
        successCallback
      );
    }

    function saveBookingItemStandardCostBased() {
      let confirmCallback = (previousProviderEmailConfirmation) => {
        vm.bookingItem.provider_id = vm.associatedProviderSelectedId;

        var documentDate = moment(vm.booking.created_at);

        let productPurchaseTaxes = TaxService.setProductTaxes(
          vm.product,
          documentDate
        ).purchaseTaxes; // , vm.taxes  TODO: vm.bookingItem.purchase_taxes ???

        if (vm.productCostType === 'per_person') {
          vm.bookingItem.adult_cost = vm.associatedProviderSelected.adults_cost;
          vm.bookingItem.child_cost = vm.associatedProviderSelected.child_cost;
          vm.bookingItem.infant_cost = vm.associatedProviderSelected.infant_cost;
          vm.bookingItem.senior_cost = vm.associatedProviderSelected.senior_cost;
        }

        let item_cost = vm.associatedProviderSelected.item_cost;
        let base_cost = TaxService.setBaseCostPrice(
          item_cost,
          vm.bookingItem.price_list,
          productPurchaseTaxes
        );
        let net_cost = base_cost;
        let pickup_cost = 0;
        let dropoff_cost = 0;
        let discount_cost = 0;
        let subtotal_cost = net_cost + pickup_cost + dropoff_cost - discount_cost;
        let tax_cost_percentage = TaxService.getProductTaxesTotalPercentage(productPurchaseTaxes);

        vm.bookingItem.purchase_taxes = TaxService.setProductTaxesAmounts(
          subtotal_cost,
          productPurchaseTaxes
        );

        let tax_cost = TaxService.getProductTaxesTotalAmount(vm.bookingItem.purchase_taxes);
        let total_cost = subtotal_cost + tax_cost;

        vm.bookingItem.item_cost = vm.UtilService.roundNum(item_cost);
        vm.bookingItem.base_cost = vm.UtilService.roundNum(base_cost);
        vm.bookingItem.net_cost = vm.UtilService.roundNum(net_cost);
        vm.bookingItem.discount_cost = vm.UtilService.roundNum(discount_cost); // conversion needed *
        vm.bookingItem.subtotal_cost = vm.UtilService.roundNum(subtotal_cost);
        vm.bookingItem.tax_cost_percentage = tax_cost_percentage;
        vm.bookingItem.tax_cost = vm.UtilService.roundNum(tax_cost);
        vm.bookingItem.total_cost = vm.UtilService.roundNum(total_cost);

        vm.bookingItem.email_confirmation = previousProviderEmailConfirmation;
        //changes notification request to pending since its a new provider
        vm.bookingItem.status = 'pending';

        // console.log(vm.bookingItem);

        vm.onBookingItemStandardCostBasedSaved({ bookingItem: vm.bookingItem });
      };

      if (vm.bookingItem.status === 'requested' || vm.bookingItem.status === 'confirmed') {
        openSendNotificationToProviderModal(vm.bookingItem, confirmCallback);
      } else {
        let params = {
          title: 'CHANGE_PROVIDER',
          body: 'CHANGING_PROVIDER_FOR_BOOKING_WARNING',
          mode: 'danger',
          // requireConfirmation: true,
        };

        ModalWindowConfirmService.open(params, confirmCallback);
      }
    }
  }
})();
